import React, { Suspense } from 'react'
import { FilterSettings } from '../types/Main'
import Spinner from './utils/Spinner'

const DrawerMode = React.lazy(() => import('./DrawerMode'))
const HorizontalMode = React.lazy(() => import('./HorizontalMode'))
const VerticalMode = React.lazy(() => import('./VerticalMode'))
const BalloonMode = React.lazy(() => import('./BalloonMode'))

const App = (
  props: FilterSettings & { closeDrawer(): void }
): React.ReactElement => {
  const { mode } = props

  switch (mode) {
    case 'drawer':
      return (
        <Suspense fallback={<Spinner />}>
          <DrawerMode {...props} />
        </Suspense>
      )
    case 'horizontal':
      return (
        <Suspense fallback={<Spinner />}>
          <HorizontalMode {...props} />
        </Suspense>
      )
    case 'vertical':
      return (
        <Suspense fallback={<Spinner />}>
          <VerticalMode {...props} />
        </Suspense>
      )
    case 'balloon':
      return (
        <Suspense fallback={<Spinner />}>
          <BalloonMode {...props} />
        </Suspense>
      )
    default:
      return <div>O modo de exibição escolhido não é válido!</div>
  }
}

export default App
